export interface Setting {
    Category: string;
    Name: string;
    Value: any;
}
export enum LookupValueDisplayMode {
    Short,
    Long,
    ShortAndLong
}

export const SettingCategory = {
    SettingCategoryLayout: "Layout",
    SettingCategoryRetrievalTemplate: "RetrievalTemplate",
    SettingCategoryDataEntryTemplate: "DataEntryTemplate",
    SettingCategoryDataEntry: "DataEntry",
    SettingCategoryDataEntryFolder: "DataEntryFolder",
    SettingCategoryPackage: "Packaging",
    SettingCategoryHitlist: "HitList",
    SettingCategoryViewer: "Viewer",
    SettingCategoryAdminDevice: "DeviceAdministration",
    SettingCategoryPrint: "Print"
}

export const SettingCategoryName = {
    SettingCategoryNameSettingDock: "DockLayout",
    SettingCategoryNameSettingHeight: "HeightLocal",
    SettingCategoryNameSettingWidth: "WidthLocal",
    SettingCategoryNameSettingMaximized: "MaximizedLocal",
    SettingCategoryNameSettingLeft: "LeftLocal",
    SettingCategoryNameSettingTop: "TopLocal",
    SettingCategoryNameSettingLastNavigationPane: "LastNavigationPane",
    SettingCategoryNameSettingThumbnailSize: "DefaultThumbnailSize",
    SettingCategoryNameSettingLastRetrievalTemplateApplication: "LastRetrievalTemplateApplication",
    SettingCategoryNameSettingLastRetrievalTemplate: "LastRetrievalTemplate",
    SettingCategoryNameSettingLastDataEntryTemplate: "LastDataEntryTemplate",
    SettingCategoryNameSettingAppendDocsToViewer: "AppendDocsToViewer",
    SettingCategoryNameSettingViewerDisplayMode: "ViewerDisplayMode",
    SettingCategoryNameSettingViewerUserDisabledExtensions: "ViewerUserDisabledExtensions",
    SettingCategoryNameSettingViewerGlobalDisabledExtensions: "ViewerGlobalDisabledExtensions",
    SettingCategoryNameSettingSearchAfterIndexing: "SearchAfterIndexing",
    SettingCategoryNameSettingMaxHits: "MaxHits",
    SettingCategoryNameSettingIsAutoLaunchViewerEnabled: "AutoLaunchViewer",
    SettingCategoryNameSettingAutoLaunchViewerCount: "AutoLaunchViewerCount",
    SettingCategoryNameSettingAutoSelectNextFolder: "AutoSelectNextFolder",
    SettingCategoryNameSettingIsOutlookBarMinimized: "IsOutlookBarMinimized",
    SettingCategoryNameSettingShowDataEntryThumbnails: "ShowDataEntryThumbnails",
    SettingCategoryNameSettingLastIndexingFunction: "LastIndexingFunction",
    SettingCategoryNameSettingShowDataEntryToolBar: "ShowDataEntryToolbar",
    SettingCategoryNameSettingLastStoreDeviceId: "LastStoreDeviceID",
    SettingCategoryNameSettingPrintPreview: "PrintPreview",
    SettingCategoryNameSettingPrintGridLines: "PrintGridLines",
    SettingCategoryNameSettingPrintColumnHeaders: "PrintColumnHeaders",
    SettingCategoryNameSettingPrintPageOrientation: "PrintPageOrientation",
    SettingCategoryNameSettingStagingFolder: "StagingFolder",
    SettingCategoryNameSettingIsHitListRibbonMinimized: "IsHitListRibbonMinimized",
    SettingCategoryNameSettingShowGroupPanel: "ShowGroupPanel",
    SettingCategoryNameSettingShowThumbnailImages: "ShowThumbnailImages",
    SettingCategoryNameDisplayMode: "LookupDisplayMode"
}